import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function LabView(props) {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [labData, setLabData] = useState([]);
    const [iplabData, setIpLabData] = useState([]);
    const [resData, setResData] = useState([]);
    const [resipData, setResIpData] = useState([]);
    useEffect(() => {
        fetchData();
        fetchIpData();
        const intervalId = setInterval(fetchData, 12000); // Fetch data every 5 seconds
        return () => clearInterval(intervalId);
    }, [selectedDate]);
    function fetchData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(baseUrl + 'lab-entry-view/' + formattedDate + '/')
            .then(response => {
                setLabData(response.data);
                const apptIds = Array.from(new Set(response.data.map(row => row.appt_id)));
                Promise.all(apptIds.map(apptId =>
                    axios.get(baseUrl + 'lab-report-all/' + apptId + '/')
                ))
                    .then(responses => {
                        const resData = responses.reduce((acc, response) => [...acc, ...response.data], []);
                        setResData(resData);
                    })
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchIpData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(baseUrl + 'ip-lab-entry-view/' + formattedDate + '/')
            .then(response => {
                setIpLabData(response.data);
                const apptIds = Array.from(new Set(response.data.map(row => row.appt_id)));
                Promise.all(apptIds.map(apptId =>
                    axios.get(baseUrl + 'ip-lab-report-all/' + apptId + '/')
                ))
                    .then(responses => {
                        const resipData = responses.reduce((acc, response) => [...acc, ...response.data], []);
                        setResIpData(resipData);
                    })
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> View OP Lab Order History</h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th align="left">S.No</th>
                        <th align="left">Appt ID</th>
                        <th align="left">Patient ID</th>
                        <th align="left">Patient</th>
                        <th align="left">Particulars</th>
                        <th align="left">Addedby</th>
                        <th align="left">Request On</th>
                        <th align="left">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {labData.filter((row) => {
                        const labTestIds = row.ltest_id.split(',').map((test) => test.trim());
                        const labTestNames = row.lab_test.split(',').map((test1) => test1.trim());
                        return labTestNames.some((test1) => !resData.some((resRow) => resRow.appt_id === row.appt_id && resRow.lab_test === test1));
                    }).map((row, index) => {
                        const labTestIds = row.ltest_id.split(',').map((test) => test.trim());
                        const labTestNames = row.lab_test.split(',').map((test1) => test1.trim());
                        const apptId = row.appt_id;
                        const filteredTestIds = labTestIds.filter((test) => !resData.some((resRow) => resRow.appt_id === apptId && resRow.ltest_id === test));
                        const filteredTestNames = labTestNames.filter((test1) => !resData.some((resRow) => resRow.appt_id === apptId && resRow.lab_test === test1));
                        const filteredTests = filteredTestIds.map((test, subIndex) => {
                            const testIndex = labTestIds.findIndex((testId) => testId === test);
                            return {test: labTestNames[testIndex], id: test};
                        });
                        return (
                            filteredTests.map((test, subIndex) => (
                                <tr key={`${index}-${subIndex}`}>
                                    <td style={{
                                        border: "1px solid",
                                        borderColor: "#2194d9"
                                    }}>{index + subIndex + 1}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{apptId}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.pat_id}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.patient}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        {test.test}
                                    </td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.addedby}</td>
                                    <td style={{
                                        border: "1px solid",
                                        borderColor: "#2194d9"
                                    }}>{row.add_date}<br></br>{row.add_time?.split('.')[0]}</td>
                                    <td><Link to={`/lab-result-entry/${apptId}/${test.id}`}
                                              className="btn btn-success">View</Link></td>
                                </tr>
                            ))
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> View IP Lab Order History</h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th align="left">S.No</th>
                        <th align="left">Appt ID</th>
                        <th align="left">Patient ID</th>
                        <th align="left">Patient</th>
                        <th align="left">Particulars</th>
                        <th align="left">Addedby</th>
                        <th align="left">Request On</th>
                        <th align="left">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {iplabData.filter((row) => {
                        const labTestIds = row.ltest_id.split(',').map((test) => test.trim());
                        const labTestNames = row.lab_test.split(',').map((test1) => test1.trim());
                        return labTestNames.some((test1) => !resipData.some((resipRow) => resipRow.appt_id === row.appt_id && resipRow.lab_test === test1));
                    }).map((row, index) => {
                        const labTestIds = row.ltest_id.split(',').map((test) => test.trim());
                        const labTestNames = row.lab_test.split(',').map((test1) => test1.trim());
                        const apptId = row.appt_id;
                        const ipId = row.ip.id;
                        const filteredTestIds = labTestIds.filter((test) => !resipData.some((resipRow) => resipRow.appt_id === apptId && resipRow.ltest_id === test));
                        const filteredTestNames = labTestNames.filter((test1) => !resipData.some((resipRow) => resipRow.appt_id === apptId && resipRow.lab_test === test1));
                        const filteredTests = filteredTestIds.map((test, subIndex) => {
                            const testIndex = labTestIds.findIndex((testId) => testId === test);
                            return {test: labTestNames[testIndex], id: test};
                        });
                        return (
                            filteredTests.map((test, subIndex) => (
                                <tr key={`${index}-${subIndex}`}>
                                    <td style={{
                                        border: "1px solid",
                                        borderColor: "#2194d9"
                                    }}>{index + subIndex + 1}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{apptId}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.pat_id}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.patient}</td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        {test.test}
                                    </td>
                                    <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.addedby}</td>
                                    <td style={{
                                        border: "1px solid",
                                        borderColor: "#2194d9"
                                    }}>{row.add_date}<br></br>{row.add_time?.split('.')[0]}</td>
                                    <td><Link to={`/ip-lab-result-entry/${apptId}/${test.id}/${ipId}`}
                                              className="btn btn-success">View</Link></td>
                                </tr>
                            ))
                        );
                    })}

                    </tbody>
                </table>
            </div>
        </section>
    )
}
export default LabView;
